import { render, staticRenderFns } from "./TcInscriptionSending.vue?vue&type=template&id=68b3063e&"
import script from "./TcInscriptionSending.vue?vue&type=script&lang=js&"
export * from "./TcInscriptionSending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b3063e')) {
      api.createRecord('68b3063e', component.options)
    } else {
      api.reload('68b3063e', component.options)
    }
    module.hot.accept("./TcInscriptionSending.vue?vue&type=template&id=68b3063e&", function () {
      api.rerender('68b3063e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcInscriptionSending.vue"
export default component.exports